import {
  ControlcenterMelcoModelsSupplier,
  SuppliersApi,
  useAPIAction,
} from "melco-shared-logic";
import { useFormikContext } from "formik";
import { QueryObserverResult } from "react-query";
import { useState } from "react";
import { supplierToInitialValues } from "../../components/suppliers/form/SupplierEditForm";

export const useRevertSupplier = (
  supplierId: string,
  refetch: () => Promise<
    QueryObserverResult<ControlcenterMelcoModelsSupplier, unknown>
  >
) => {
  const dateOfLastRevert = new Date().getTime();
  const [revertKey, setRevertKey] = useState(dateOfLastRevert);
  const { resetForm } = useFormikContext();

  return [
    ...useAPIAction(
      SuppliersApi,
      async (api) => {
        const data = await api.supplierRevert({
          id: supplierId,
        });

        return {
          successMessages: [
            {
              message: "default",
            },
          ],
          data,
        };
      },
      {
        translationPrefix: "managesuppliers.actions.revert",
        onSuccess: async () => {
          const refetchResult = await refetch();

          resetForm({
            values: refetchResult.data
              ? supplierToInitialValues(refetchResult.data)
              : {},
          });

          // wait until formik values have changed
          await Promise.resolve();

          // trigger re-initialization of renderer
          const dateOfRevert = new Date().getTime();
          setRevertKey(dateOfRevert);
        },
      }
    ),
    revertKey,
  ] as const;
};
